import { Form, Tooltip } from "antd";
import { useEffect, useState } from "react";
import { GetAntIcon } from "../utils/ant_icons";
import ReorderList from "./ReorderList";

function ReorderListFormItem({
	disabled,
	item,
	dataObject,
	activeRowKey,
	activeRecord,
	formRef,
	setFormReset,
}: {
	disabled: boolean;
	item: any;
	dataObject: any;
	activeRowKey: string;
	activeRecord: any;
	formRef: any;
	setFormReset: any;
}) {
	const [currentDataObject, setCurrentDataObject] = useState<any>([]);

	useEffect(() => {
		const _dataObject = dataObject?.[item.name]?.[activeRowKey] ||
			dataObject?.[item.name] || [...(activeRecord?.[item.name] ?? [])];
		setCurrentDataObject(_dataObject);
	}, [dataObject, activeRowKey, activeRecord]);

	const handleReorder = (data: any) => {
		data.forEach((_item: any, index: number) => {
			_item.sequence_id = index;
		});
		formRef.setFieldValue(item.name, data);
		setFormReset(false);
	};

	if (currentDataObject?.length > 0) {
		return (
			<div className="reorder-list">
				<div style={{ display: "flex", gap: "2px" }}>
					<span>{item.label}</span>
					{item.tooltip && (
						<Tooltip title={item.tooltip} placement="right">
							<span style={{ color: "rgba(255,255,255,0.45)" }}>
								{GetAntIcon("question3")}
							</span>
						</Tooltip>
					)}
				</div>
				<Form.Item
					style={{ display: "none" }}
					name={item.name}
					rules={[{ required: item.required, message: "" }]}
				/>
				<ReorderList
					draggable={item.draggable}
					disabled={disabled || item.disabled || item.readOnly}
					data={currentDataObject}
					itemKey={item.labelKey}
					onReorder={handleReorder}
					activeRowKey={activeRowKey}
				/>
			</div>
		);
	} else {
		return <></>;
	}
}

export default ReorderListFormItem;
